var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoNobackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 158,
    viewBox: "0 0 513 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7782 0H24.3216C8.44055 0 0.5 7.9405 0.5 23.8214V77.0106C0.5 92.8916 8.44055 100.832 24.3216 100.832H44.7782C60.6593 100.832 68.5998 92.8916 68.5998 77.0106V23.8214C68.5998 7.9405 60.6593 0 44.7782 0ZM24.7606 16.2268H43.5678L18.4826 69.5357V22.5047C18.4826 18.315 20.5708 16.2268 24.7606 16.2268ZM44.3393 84.6186H26.0773L50.6172 32.4535V78.3274C50.6172 82.5171 48.5157 84.6053 44.3393 84.6053V84.6186Z",
    fill: "url(#paint0_linear_775_2477)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.373 70.6713L194.497 56.7188V157.551H176.373V93.398L158.824 106.919L144.153 118.282L129.337 106.919L111.789 93.398V157.551H93.8086V56.7188L111.789 70.6713L144.153 95.5556L176.373 70.6713Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.96 157.551L306.755 139.427L264.609 56.7188L254.544 76.4722L271.35 109.592L286.617 139.427L295.823 157.551H315.96ZM261.101 103.32L242.746 139.427L233.54 157.551H213.402L222.464 139.427L251.003 83.421L261.101 103.32Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.083 57.0056V56.7187L429.94 57.0056H407.277L379.882 92.4331L379.865 92.4104L368.672 107.034L368.695 107.063L363.47 113.83L355.091 124.777L355.045 124.742L329.825 157.407V157.551H352.343L379.882 121.693L407.564 157.551H430.083L391.213 107.063L429.94 57.0056H430.083ZM364.683 101.877L375.887 87.2391L352.63 57.0056H329.968L329.825 56.7187V57.0056H329.968L364.683 101.877Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M450.248 100.819V84.5941H473.627V16.2113H454.49V6.71594L463.108 0H491.461V84.6075H512.499V100.832H450.261L450.248 100.819Z",
    fill: "url(#paint1_linear_775_2477)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_775_2477",
    x1: 34.5499,
    y1: 0,
    x2: 34.5499,
    y2: 100.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_775_2477",
    x1: 481.374,
    y1: 0,
    x2: 481.374,
    y2: 100.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E4FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNobackground);
export default __webpack_public_path__ + "static/media/logo-nobackground.1d76058d19f0c24cbf59c1453d097801.svg";
export { ForwardRef as ReactComponent };